export class User {
    id: number;
    name: string;
    userName: string;
    emailAddress: string;
    countryCode: string;
    phoneNumber: string;
    surname: string;
    token: string;
}